const focus = el => el.focus();

export default {
  focus,
};
